import { graphql } from '@teachino/shared-infrastructure';

export const planFragment = graphql(`
  fragment plan on Plan @_unmask {
    id
    billingCycle
    defaultForKey
    defaultPriceMonth
    type
  }
`);
